const UserSickness = {
  getlist: 'UserSickness/get-by-admin',
}
export default UserSickness
